import React from 'react';
import { type GridStyles } from '../../utils/grid-styles';

export interface FieldContextValue {
  gridStyles: Omit<GridStyles, 'container'>;
}

export const FieldContext = React.createContext<FieldContextValue | null>(null);

export function useFieldContext(): FieldContextValue {
  const context = React.useContext(FieldContext);

  if (!context) {
    throw new Error(
      'Field components must be used within a Form.Field component',
    );
  }

  return context;
}
